export const getPageViewExperimentId = isSelectClaimEnabled =>
  isSelectClaimEnabled
    ? process.env.SELECT_CLAIM_LOGIN_EXPERIMENT_ID
    : process.env.LEGACY_LOGIN_EXPERIMENT_ID
